var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container pt-3" }, [
    _c("img", { staticClass: "mt-5", attrs: { src: _vm.logo, height: "50" } }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "gv-container-header d-flex flex-column align-items-center pt-5 justify-content-center text-center",
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("p", { staticClass: "text-muted mb-0" }, [
          _vm._v("Esta página no está disponible públicamente."),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-muted" }, [
          _vm._v("Para acceder por favor inicie sesión primero"),
        ]),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "btn btn-h btn-dark",
            attrs: { to: { name: "Login" } },
          },
          [_vm._v("Iniciar sessión")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "display-1 text-muted" }, [
      _c("strong", [_vm._v("401")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "title" }, [
      _c("strong", [_vm._v("No se encontró ninguna autorización")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }